export enum TaskCollectionTravelMode {
  Driving = 0,
  PublicTransport = 1,
  Walking = 2,
  Cycling = 3,
}
